import { z } from 'zod';

export const ServiceLikeResponse = z.object({
  likeCount: z.number().int(),
  isLikedByMe: z.boolean(),
});
export type ServiceLikeResponse = z.infer<typeof ServiceLikeResponse>;
